// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1RDUi","footer":"ReportModalFilter_footer__2MgUX"};